import { useTranslation } from "react-i18next";
import { useCallback } from "react";
import { changeLanguage as changeI18nLanguage, type Language } from "@/i18n";

export type { Language };

/**
 * Compatibility wrapper that mimics the Vue composable's API surface
 * (`language`, `setLanguage`, `t`) using react-i18next under the hood.
 */
export function useLanguage() {
  const { t, i18n } = useTranslation();

  const setLanguage = useCallback(async (lang: Language) => {
    await changeI18nLanguage(lang);
  }, []);

  const language = (i18n.language || "pt") as Language;

  return {
    language,
    setLanguage,
    t: t as (key: string, params?: Record<string, string | number>) => string,
  };
}
